import React from 'react';
import { useRouteMatch, Route } from 'react-router-dom';
import { IHasPageChangeRef } from '../../../../../../main/interface/has-page-change';
import { ConfigurationModuleRegistry } from './module-registry';

interface IMatch {
  path: string;
  url: string;
  params: {
    submodule: string;
    thirdLevelRoute?: string;
    fourthLevelRoute?: string;
    formId: string;
  }
}

interface IConfigurationModuleProps {
  hasPageChangeRef: React.MutableRefObject<IHasPageChangeRef>;
}

const ConfigurationModule: React.FC<IConfigurationModuleProps> = (props) => {
  const match: IMatch = useRouteMatch();
  return (
    <Route path={`${match.path}`}>
      <ConfigurationModuleRegistry.Render
        type={match.params.fourthLevelRoute || ''}
        hasPageChangeRef={props.hasPageChangeRef}
      />
    </Route>
  );
}

export default ConfigurationModule;